import { render, staticRenderFns } from "./SystemNotification.vue?vue&type=template&id=4d524046&scoped=true&lang=pug"
import script from "./SystemNotification.vue?vue&type=script&lang=js"
export * from "./SystemNotification.vue?vue&type=script&lang=js"
import style0 from "./SystemNotification.vue?vue&type=style&index=0&id=4d524046&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d524046",
  null
  
)

export default component.exports